import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="date-picker"
export default class extends Controller {
  static targets = [ "day", "month", "year", "overlay", "container" ]

  connect() {
  }
  
  showForm() {
    this.overlayTarget.style.zIndex = "-1"
    this.containerTarget.style.zIndex = "0"
    this.monthTarget.focus()
  }

  validateDay(event) {
    var val = this.dayTarget.value
    if (val.length >= 2 || ["4", "5", "6", "7", "8", "9"].includes(val)) {
      this.yearTarget.focus()
    }
  }

  validateMonth(event) {
    var val = this.monthTarget.value
    if (val.length >= 2 || ["2", "3", "4", "5", "6", "7", "8", "9"].includes(val)) {
      this.dayTarget.focus()
    }
  }

  validateYear(event) {

  }
}
